import * as React from "react";
import { Alert } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { useCanRenderAdvanced } from "./useCanRenderAdvanced";
import { parseLink } from "../../../../utils/linkParser/linkParser";

interface Props {}
export const PortsDedicatedLBCheck: React.FC<Props> = () => {
  const canRender = useCanRenderAdvanced();
  const routingMode = useCpFormValue("advanced.spec.routingMode");

  const gvcLink = useCpFormValue("gvc.link");
  const gvcName = React.useMemo(() => {
    const parsedLink = parseLink(gvcLink, { useInputCtx: true });
    return parsedLink.name;
  }, [gvcLink]);

  const workloadLink = useCpFormValue("advanced.spec.workload.link");
  const workloadName = React.useMemo(() => {
    const parsedLink = parseLink(workloadLink, { useInputCtx: true });
    return parsedLink.name;
  }, [workloadLink]);

  const ports = useCpFormValue("advanced.spec.ports") || [];

  const dedicatedLoadBalancerRequirement: {
    isRequired: boolean;
    reason: string;
  } = React.useMemo(() => {
    let isRequired = false;
    let reason = "";

    for (const portIndexStr in ports) {
      const portIndex = Number(portIndexStr);
      const port = ports[portIndex];
      if (!port.number) {
        continue;
      }

      if (String(port.number) !== "443" && String(port.number) !== "80" && port.protocol === "tcp") {
        isRequired = true;
        reason = "numbertcp";
      } else if (String(port.number) !== "443" && String(port.number) !== "80") {
        isRequired = true;
        reason = "number";
      } else if (port.protocol === "tcp") {
        isRequired = true;
        reason = "tcp";
      }
    }

    return { isRequired, reason };
  }, [ports]);

  if (routingMode === "workloadSubdomain" && (!workloadName || !gvcName)) {
    return null;
  }

  if (routingMode === "pathBased" && !gvcName) {
    return null;
  }

  if (!canRender) {
    return null;
  }

  return (
    <>
      {dedicatedLoadBalancerRequirement.isRequired ? (
        <>
          {dedicatedLoadBalancerRequirement.reason === "numbertcp" ? (
            <Alert
              showIcon
              type={`warning`}
              className="w-fit"
              message={`Dedicated Load Balancer is Required`}
              description={`Domain with ports using TCP protocol and port numbers other than 443 and 80 requires Dedicated Load Balancer on the GVC that it is targeting`}
            />
          ) : null}

          {dedicatedLoadBalancerRequirement.reason === "number" ? (
            <Alert
              showIcon
              type={`warning`}
              className="w-fit"
              message={`Dedicated Load Balancer is Required`}
              description={`Domain with ports using port numbers other than 443 and 80 requires Dedicated Load Balancer on the GVC that it is targeting`}
            />
          ) : null}

          {dedicatedLoadBalancerRequirement.reason === "tcp" ? (
            <Alert
              showIcon
              type={`warning`}
              className="w-fit"
              message={`Dedicated Load Balancer is Required`}
              description={`Domain with ports using TCP protocol requires Dedicated Load Balancer on the GVC that it is targeting`}
            />
          ) : null}
        </>
      ) : null}
    </>
  );
};
